import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CHAT_GPT, ZAPIER } from 'drapcode-constant';
import * as actions from './redux/actions';
import ExternalApiHeaderNav from './ExternalApiHeaderNav';
import ZapierExternalApiForm from './zapier/ZapierExternalApiForm';
import ParentContentCard from '../common/ParentContentCard';
import ParentDocCard from '../common/ParentDocCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import { parseExtractPluginCode } from '../../common/utils/plugin_utils';
import { checkToShowSaveBtn } from '../plugin/utils';
import { checkExternalAPIPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class ExternalZapierUpdate extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { headers: [] };

  componentDidMount = () => {
    const { match, actions, home } = this.props;
    const { projectId, externalApiId, version } = match.params;
    actions.loadCollections({ projectId, version });
    const { iPlugins } = home;
    if (externalApiId) {
      actions.loadExternalApi({ externalApiId, projectId, version });
    }
    const headers = parseExtractPluginCode(iPlugins, 'EXTERNALAPI');
    this.setState({ headers });
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome, match } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    if (!checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const headers = parseExtractPluginCode(nextIPlugins, 'EXTERNALAPI');
      this.setState({ headers });
    }
    return true;
  }

  render() {
    const isAllowed = checkExternalAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Zapier" />;
    }
    const { match, externalapi, actions, history, home } = this.props;
    const { loadExternalApiPending } = externalapi;
    if (loadExternalApiPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={loadExternalApiPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }
    const { projectId, externalApiId, version } = match.params;
    const { iPlugins } = home;
    const chatGptPlugin = iPlugins && iPlugins.find((e) => e.code === CHAT_GPT);
    const { headers } = this.state;
    return (
      <CommonPageComponent>
        <ExternalApiHeaderNav
          version={version}
          activeTab={ZAPIER}
          projectId={projectId}
          headers={headers}
          enableChatGpt={chatGptPlugin ? true : false}
        />
        <div className="row mx-auto">
          <ParentContentCard icon={ZAPIER} title="Zapier">
            <ZapierExternalApiForm
              projectId={projectId}
              externalApiId={externalApiId}
              history={history}
              externalApiType={ZAPIER}
              actions={actions}
              externalapi={externalapi}
              version={version}
            />
          </ParentContentCard>
          <ParentDocCard>
            <h5>
              <b>About Zapier API</b>
            </h5>
            <p>DrapCode supports Zapier to send or process data using Zapier API integration.</p>
            <br />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalZapierUpdate);
